export const pmPhoneCodeOptions = [
  { 'text': 'Afghanistan (+93)', 'value': 'AFG_93' },
  { 'text': 'Åland Islands (+358)', 'value': 'ALA_358' },
  { 'text': 'Albania (+355)', 'value': 'ALB_355' },
  { 'text': 'Algeria (+213)', 'value': 'DZA_213' },
  { 'text': 'American Samoa (+1)', 'value': 'ASM_1' },
  { 'text': 'Andorra (+376)', 'value': 'AND_376' },
  { 'text': 'Angola (+244)', 'value': 'AGO_244' },
  { 'text': 'Anguilla (+1)', 'value': 'AIA_1' },
  { 'text': 'Antigua and Barbuda (+1)', 'value': 'ATG_1' },
  { 'text': 'Argentina (+54)', 'value': 'ARG_54' },
  { 'text': 'Armenia (+374)', 'value': 'ARM_374' },
  { 'text': 'Aruba (+297)', 'value': 'ABW_297' },
  { 'text': 'Australia (+61)', 'value': 'AUS_61' },
  { 'text': 'Austria (+43)', 'value': 'AUT_43' },
  { 'text': 'Azerbaijan (+994)', 'value': 'AZE_994' },
  { 'text': 'Bahamas (+1)', 'value': 'BHS_1' },
  { 'text': 'Bahrain (+973)', 'value': 'BHR_973' },
  { 'text': 'Bangladesh (+880)', 'value': 'BGD_880' },
  { 'text': 'Barbados (+1)', 'value': 'BRB_1' },
  { 'text': 'Belarus (+375)', 'value': 'BLR_375' },
  { 'text': 'Belgium (+32)', 'value': 'BEL_32' },
  { 'text': 'Belize (+501)', 'value': 'BLZ_501' },
  { 'text': 'Benin (+229)', 'value': 'BEN_229' },
  { 'text': 'Bermuda (+1)', 'value': 'BMU_1' },
  { 'text': 'Bhutan (+975)', 'value': 'BTN_975' },
  { 'text': 'Bolivia (+591)', 'value': 'BOL_591' },
  { 'text': 'Bonaire, Sint Eustatius, and Saba (+599)', 'value': 'BES_599' },
  { 'text': 'Bosnia and Herzegovina (+387)', 'value': 'BIH_387' },
  { 'text': 'Botswana (+267)', 'value': 'BWA_267' },
  { 'text': 'Brazil (+55)', 'value': 'BRA_55' },
  { 'text': 'British Indian Ocean Territory (+246)', 'value': 'IOT_246' },
  { 'text': 'British Virgin Islands (+1)', 'value': 'VGB_1' },
  { 'text': 'Brunei (+673)', 'value': 'BRN_673' },
  { 'text': 'Bulgaria (+359)', 'value': 'BGR_359' },
  { 'text': 'Burkina Faso (+226)', 'value': 'BFA_226' },
  { 'text': 'Burundi (+257)', 'value': 'BDI_257' },
  { 'text': 'Cabo Verde (+238)', 'value': 'CPV_238' },
  { 'text': 'Cambodia (+855)', 'value': 'KHM_855' },
  { 'text': 'Cameroon (+237)', 'value': 'CMR_237' },
  { 'text': 'Canada (+1)', 'value': 'CAN_1' },
  { 'text': 'Cayman Islands (+1)', 'value': 'CYM_1' },
  { 'text': 'Central African Republic (+236)', 'value': 'CAF_236' },
  { 'text': 'Chad (+235)', 'value': 'TCD_235' },
  { 'text': 'Chile (+56)', 'value': 'CHL_56' },
  { 'text': 'China (+86)', 'value': 'CHN_86' },
  { 'text': 'Christmas Island (+61)', 'value': 'CXR_61' },
  { 'text': 'Cocos (Keeling) Islands (+61)', 'value': 'CCK_61' },
  { 'text': 'Colombia (+57)', 'value': 'COL_57' },
  { 'text': 'Comoros (+269)', 'value': 'COM_269' },
  { 'text': 'Congo (+242)', 'value': 'COG_242' },
  { 'text': 'Congo, Democratic Republic of the (+243)', 'value': 'COD_243' },
  { 'text': 'Cook Islands (+682)', 'value': 'COK_682' },
  { 'text': 'Costa Rica (+506)', 'value': 'CRI_506' },
  { 'text': 'Côte d\'Ivoire (+225)', 'value': 'CIV_225' },
  { 'text': 'Croatia (+385)', 'value': 'HRV_385' },
  { 'text': 'Cuba (+53)', 'value': 'CUB_53' },
  { 'text': 'Curaçao (+599)', 'value': 'CUW_599' },
  { 'text': 'Cyprus (+357)', 'value': 'CYP_357' },
  { 'text': 'Czechia (+420)', 'value': 'CZE_420' },
  { 'text': 'Denmark (+45)', 'value': 'DNK_45' },
  { 'text': 'Djibouti (+253)', 'value': 'DJI_253' },
  { 'text': 'Dominica (+1)', 'value': 'DMA_1' },
  { 'text': 'Dominican Republic (+1)', 'value': 'DOM_1' },
  { 'text': 'Ecuador (+593)', 'value': 'ECU_593' },
  { 'text': 'Egypt (+20)', 'value': 'EGY_20' },
  { 'text': 'El Salvador (+503)', 'value': 'SLV_503' },
  { 'text': 'Equatorial Guinea (+240)', 'value': 'GNQ_240' },
  { 'text': 'Eritrea (+291)', 'value': 'ERI_291' },
  { 'text': 'Estonia (+372)', 'value': 'EST_372' },
  { 'text': 'Eswatini (+268)', 'value': 'SWZ_268' },
  { 'text': 'Ethiopia (+251)', 'value': 'ETH_251' },
  { 'text': 'Falkland Islands (+500)', 'value': 'FLK_500' },
  { 'text': 'Faroe Islands (+298)', 'value': 'FRO_298' },
  { 'text': 'Fiji (+679)', 'value': 'FJI_679' },
  { 'text': 'Finland (+358)', 'value': 'FIN_358' },
  { 'text': 'France (+33)', 'value': 'FRA_33' },
  { 'text': 'French Guiana (+594)', 'value': 'GUF_594' },
  { 'text': 'French Polynesia (+689)', 'value': 'PYF_689' },
  { 'text': 'Gabon (+241)', 'value': 'GAB_241' },
  { 'text': 'Gambia (+220)', 'value': 'GMB_220' },
  { 'text': 'Georgia (+995)', 'value': 'GEO_995' },
  { 'text': 'Germany (+49)', 'value': 'DEU_49' },
  { 'text': 'Ghana (+233)', 'value': 'GHA_233' },
  { 'text': 'Gibraltar (+350)', 'value': 'GIB_350' },
  { 'text': 'Greece (+30)', 'value': 'GRC_30' },
  { 'text': 'Greenland (+299)', 'value': 'GRL_299' },
  { 'text': 'Grenada (+1)', 'value': 'GRD_1' },
  { 'text': 'Guadeloupe (+590)', 'value': 'GLP_590' },
  { 'text': 'Guam (+1)', 'value': 'GUM_1' },
  { 'text': 'Guatemala (+502)', 'value': 'GTM_502' },
  { 'text': 'Guernsey (+44)', 'value': 'GGY_44' },
  { 'text': 'Guinea (+224)', 'value': 'GIN_224' },
  { 'text': 'Guinea-Bissau (+245)', 'value': 'GNB_245' },
  { 'text': 'Guyana (+592)', 'value': 'GUY_592' },
  { 'text': 'Haiti (+509)', 'value': 'HTI_509' },
  { 'text': 'Holy See (Vatican City State) (+39)', 'value': 'VAT_39' },
  { 'text': 'Honduras (+504)', 'value': 'HND_504' },
  { 'text': 'Hong Kong (+852)', 'value': 'HKG_852' },
  { 'text': 'Hungary (+36)', 'value': 'HUN_36' },
  { 'text': 'Iceland (+354)', 'value': 'ISL_354' },
  { 'text': 'India (+91)', 'value': 'IND_91' },
  { 'text': 'Indonesia (+62)', 'value': 'IDN_62' },
  { 'text': 'Iran (+98)', 'value': 'IRN_98' },
  { 'text': 'Iraq (+964)', 'value': 'IRQ_964' },
  { 'text': 'Ireland (+353)', 'value': 'IRL_353' },
  { 'text': 'Isle of Man (+44)', 'value': 'IMN_44' },
  { 'text': 'Israel (+972)', 'value': 'ISR_972' },
  { 'text': 'Italy (+39)', 'value': 'ITA_39' },
  { 'text': 'Jamaica (+1)', 'value': 'JAM_1' },
  { 'text': 'Japan (+81)', 'value': 'JPN_81' },
  { 'text': 'Jersey (+44)', 'value': 'JEY_44' },
  { 'text': 'Jordan (+962)', 'value': 'JOR_962' },
  { 'text': 'Kazakhstan (+7)', 'value': 'KAZ_7' },
  { 'text': 'Kenya (+254)', 'value': 'KEN_254' },
  { 'text': 'Kiribati (+686)', 'value': 'KIR_686' },
  { 'text': 'Korea, Democratic People\'s Republic of (+850)', 'value': 'PRK_850' },
  { 'text': 'Korea, Republic of (+82)', 'value': 'KOR_82' },
  { 'text': 'Kosovo (+377)', 'value': 'KSV_377' },
  { 'text': 'Kosovo (+381)', 'value': 'KSV_381' },
  { 'text': 'Kosovo (+383)', 'value': 'KSV_383' },
  { 'text': 'Kosovo (+386)', 'value': 'KSV_386' },
  { 'text': 'Kuwait (+965)', 'value': 'KWT_965' },
  { 'text': 'Kyrgyzstan (+996)', 'value': 'KGZ_996' },
  { 'text': 'Laos (+856)', 'value': 'LAO_856' },
  { 'text': 'Latvia (+371)', 'value': 'LVA_371' },
  { 'text': 'Lebanon (+961)', 'value': 'LBN_961' },
  { 'text': 'Lesotho (+266)', 'value': 'LSO_266' },
  { 'text': 'Liberia (+231)', 'value': 'LBR_231' },
  { 'text': 'Libya (+218)', 'value': 'LBY_218' },
  { 'text': 'Liechtenstein (+423)', 'value': 'LIE_423' },
  { 'text': 'Lithuania (+370)', 'value': 'LTU_370' },
  { 'text': 'Luxembourg (+352)', 'value': 'LUX_352' },
  { 'text': 'Macao (+853)', 'value': 'MAC_853' },
  { 'text': 'Madagascar (+261)', 'value': 'MDG_261' },
  { 'text': 'Malawi (+265)', 'value': 'MWI_265' },
  { 'text': 'Malaysia (+60)', 'value': 'MYS_60' },
  { 'text': 'Maldives (+960)', 'value': 'MDV_960' },
  { 'text': 'Mali (+223)', 'value': 'MLI_223' },
  { 'text': 'Malta (+356)', 'value': 'MLT_356' },
  { 'text': 'Marshall Islands (+692)', 'value': 'MHL_692' },
  { 'text': 'Martinique (+596)', 'value': 'MTQ_596' },
  { 'text': 'Mauritania (+222)', 'value': 'MRT_222' },
  { 'text': 'Mauritius (+230)', 'value': 'MUS_230' },
  { 'text': 'Mayotte (+262)', 'value': 'MYT_262' },
  { 'text': 'Mexico (+52)', 'value': 'MEX_52' },
  { 'text': 'Micronesia, Federated States of (+691)', 'value': 'FSM_691' },
  { 'text': 'Moldova (+373)', 'value': 'MDA_373' },
  { 'text': 'Monaco (+377)', 'value': 'MCO_377' },
  { 'text': 'Mongolia (+976)', 'value': 'MNG_976' },
  { 'text': 'Montenegro (+382)', 'value': 'MNE_382' },
  { 'text': 'Montserrat (+1)', 'value': 'MSR_1' },
  { 'text': 'Morocco (+212)', 'value': 'MAR_212' },
  { 'text': 'Mozambique (+258)', 'value': 'MOZ_258' },
  { 'text': 'Myanmar (+95)', 'value': 'MMR_95' },
  { 'text': 'Namibia (+264)', 'value': 'NAM_264' },
  { 'text': 'Nauru (+674)', 'value': 'NRU_674' },
  { 'text': 'Nepal (+977)', 'value': 'NPL_977' },
  { 'text': 'Netherlands (+31)', 'value': 'NLD_31' },
  { 'text': 'New Caledonia (+687)', 'value': 'NCL_687' },
  { 'text': 'New Zealand (+64)', 'value': 'NZL_64' },
  { 'text': 'Nicaragua (+505)', 'value': 'NIC_505' },
  { 'text': 'Niger (+227)', 'value': 'NER_227' },
  { 'text': 'Nigeria (+234)', 'value': 'NGA_234' },
  { 'text': 'Niue (+683)', 'value': 'NIU_683' },
  { 'text': 'Norfolk Island (+672)', 'value': 'NFK_672' },
  { 'text': 'North Macedonia (+389)', 'value': 'MKD_389' },
  { 'text': 'Northern Mariana Islands (+1)', 'value': 'MNP_1' },
  { 'text': 'Norway (+47)', 'value': 'NOR_47' },
  { 'text': 'Oman (+968)', 'value': 'OMN_968' },
  { 'text': 'Pakistan (+92)', 'value': 'PAK_92' },
  { 'text': 'Palau (+680)', 'value': 'PLW_680' },
  { 'text': 'Panama (+507)', 'value': 'PAN_507' },
  { 'text': 'Papua New Guinea (+675)', 'value': 'PNG_675' },
  { 'text': 'Paraguay (+595)', 'value': 'PRY_595' },
  { 'text': 'Peru (+51)', 'value': 'PER_51' },
  { 'text': 'Philippines (+63)', 'value': 'PHL_63' },
  { 'text': 'Pitcairn Islands (+64)', 'value': 'PCN_64' },
  { 'text': 'Poland (+48)', 'value': 'POL_48' },
  { 'text': 'Portugal (+351)', 'value': 'PRT_351' },
  { 'text': 'Puerto Rico (+1)', 'value': 'PRI_1' },
  { 'text': 'Qatar (+974)', 'value': 'QAT_974' },
  { 'text': 'Reunion (+262)', 'value': 'REU_262' },
  { 'text': 'Romania (+40)', 'value': 'ROU_40' },
  { 'text': 'Russian Federation (+7)', 'value': 'RUS_7' },
  { 'text': 'Rwanda (+250)', 'value': 'RWA_250' },
  { 'text': 'Saint Barthelemy (+590)', 'value': 'BLM_590' },
  { 'text': 'Saint Helena, Ascension and Tristan da Cunha (+247)', 'value': 'SHN_247' },
  { 'text': 'Saint Helena, Ascension and Tristan da Cunha (+290)', 'value': 'SHN_290' },
  { 'text': 'Saint Kitts and Nevis (+1)', 'value': 'KNA_869' },
  { 'text': 'Saint Lucia (+1)', 'value': 'LCA_1' },
  { 'text': 'Saint Martin (+590)', 'value': 'MAF_590' },
  { 'text': 'Saint Pierre and Miquelon (+508)', 'value': 'SPM_508' },
  { 'text': 'Saint Vincent and the Grenadines (+1)', 'value': 'VCT_1' },
  { 'text': 'Samoa (+685)', 'value': 'WSM_685' },
  { 'text': 'San Marino (+378)', 'value': 'SMR_378' },
  { 'text': 'Sao Tome and Principe (+239)', 'value': 'STP_239' },
  { 'text': 'Saudi Arabia (+966)', 'value': 'SAU_966' },
  { 'text': 'Senegal (+221)', 'value': 'SEN_221' },
  { 'text': 'Serbia (+381)', 'value': 'SRB_381' },
  { 'text': 'Seychelles (+248)', 'value': 'SYC_248' },
  { 'text': 'Sierra Leone (+232)', 'value': 'SLE_232' },
  { 'text': 'Singapore (+65)', 'value': 'SGP_65' },
  { 'text': 'Sint Maarten (+1)', 'value': 'SXM_1' },
  { 'text': 'Slovakia (+421)', 'value': 'SVK_421' },
  { 'text': 'Slovenia (+386)', 'value': 'SVN_386' },
  { 'text': 'Solomon Islands (+677)', 'value': 'SLB_677' },
  { 'text': 'Somalia (+252)', 'value': 'SOM_252' },
  { 'text': 'South Africa (+27)', 'value': 'ZAF_27' },
  { 'text': 'South Sudan (+211)', 'value': 'SSD_211' },
  { 'text': 'Spain (+34)', 'value': 'ESP_34' },
  { 'text': 'Sri Lanka (+94)', 'value': 'LKA_94' },
  { 'text': 'State of Palestine (+970)', 'value': 'PSE_970' },
  { 'text': 'Sudan (+249)', 'value': 'SDN_249' },
  { 'text': 'Suriname (+597)', 'value': 'SUR_597' },
  { 'text': 'Svalbard and Jan Mayen (+47)', 'value': 'SJM_47' },
  { 'text': 'Sweden (+46)', 'value': 'SWE_46' },
  { 'text': 'Switzerland (+41)', 'value': 'CHE_41' },
  { 'text': 'Syria (+963)', 'value': 'SYR_963' },
  { 'text': 'Taiwan (+886)', 'value': 'TWN_886' },
  { 'text': 'Tajikistan (+992)', 'value': 'TJK_992' },
  { 'text': 'Tanzania (+255)', 'value': 'TZA_255' },
  { 'text': 'Thailand (+66)', 'value': 'THA_66' },
  { 'text': 'Timor-Leste (+670)', 'value': 'TLS_670' },
  { 'text': 'Togo (+228)', 'value': 'TGO_228' },
  { 'text': 'Tokelau (+690)', 'value': 'TKL_690' },
  { 'text': 'Tonga (+676)', 'value': 'TON_676' },
  { 'text': 'Trinidad and Tobago (+1)', 'value': 'TTO_1' },
  { 'text': 'Tunisia (+216)', 'value': 'TUN_216' },
  { 'text': 'Türkiye (+90)', 'value': 'TUR_90' },
  { 'text': 'Turkmenistan (+993)', 'value': 'TKM_993' },
  { 'text': 'Turks and Caicos Islands (+1)', 'value': 'TCA_1' },
  { 'text': 'Tuvalu (+688)', 'value': 'TUV_688' },
  { 'text': 'U. S. Virgin Islands (+1)', 'value': 'VIR_1' },
  { 'text': 'Uganda (+256)', 'value': 'UGA_256' },
  { 'text': 'Ukraine (+380)', 'value': 'UKR_380' },
  { 'text': 'United Arab Emirates (+971)', 'value': 'ARE_971' },
  { 'text': 'United Kingdom (+44)', 'value': 'GBR_44' },
  { 'text': 'United States Minor Outlying Islands (+1)', 'value': 'UMI_1' },
  { 'text': 'United States of America (+1)', 'value': 'USA_1' },
  { 'text': 'Uruguay (+598)', 'value': 'URY_598' },
  { 'text': 'Uzbekistan (+998)', 'value': 'UZB_998' },
  { 'text': 'Vanuatu (+678)', 'value': 'VUT_678' },
  { 'text': 'Venezuela (+58)', 'value': 'VEN_58' },
  { 'text': 'Vietnam (+84)', 'value': 'VNM_84' },
  { 'text': 'Wallis and Futuna (+681)', 'value': 'WLF_681' },
  { 'text': 'Western Sahara (+212)', 'value': 'ESH_212' },
  { 'text': 'Yemen (+967)', 'value': 'YEM_967' },
  { 'text': 'Zambia (+260)', 'value': 'ZMB_260' },
  { 'text': 'Zimbabwe (+263)', 'value': 'ZWE_263' },
];

export const pmPhonePrefixMap = {
  'AFG_93': '+93',
  'ALA_358': '+358',
  'ALB_355': '+355',
  'DZA_213': '+213',
  'ASM_1': '+1',
  'AND_376': '+376',
  'AGO_244': '+244',
  'AIA_1': '+1',
  'ATG_1': '+1',
  'ARG_54': '+54',
  'ARM_374': '+374',
  'ABW_297': '+297',
  'AUS_61': '+61',
  'AUT_43': '+43',
  'AZE_994': '+994',
  'BHS_1': '+1',
  'BHR_973': '+973',
  'BGD_880': '+880',
  'BRB_1': '+1',
  'BLR_375': '+375',
  'BEL_32': '+32',
  'BLZ_501': '+501',
  'BEN_229': '+229',
  'BMU_1': '+1',
  'BTN_975': '+975',
  'BOL_591': '+591',
  'BES_599': '+599',
  'BIH_387': '+387',
  'BWA_267': '+267',
  'BRA_55': '+55',
  'IOT_246': '+246',
  'VGB_1': '+1',
  'BRN_673': '+673',
  'BGR_359': '+359',
  'BFA_226': '+226',
  'BDI_257': '+257',
  'CPV_238': 'Cabo +238',
  'KHM_855': '+855',
  'CMR_237': '+237',
  'CAN_1': '+1',
  'CYM_1': '+1',
  'CAF_236': '+236',
  'TCD_235': '+235',
  'CHL_56': '+56',
  'CHN_86': '+86',
  'CXR_61': '+61',
  'CCK_61': '+61',
  'COL_57': '+57',
  'COM_269': '+269',
  'COG_242': '+242',
  'COD_243': '+243',
  'COK_682': '+682',
  'CRI_506': '+506',
  'CIV_225': '+225',
  'HRV_385': '+385',
  'CUB_53': '+53',
  'CUW_599': '+599',
  'CYP_357': '+357',
  'CZE_420': '+420',
  'DNK_45': '+45',
  'DJI_253': '+253',
  'DMA_1': '+1',
  'DOM_1': '+1',
  'ECU_593': '+593',
  'EGY_20': '+20',
  'SLV_503': '+503',
  'GNQ_240': '+240',
  'ERI_291': '+291',
  'EST_372': '+372',
  'SWZ_268': '+268',
  'ETH_251': '+251',
  'FLK_500': '+500',
  'FRO_298': '+298',
  'FJI_679': '+679',
  'FIN_358': '+358',
  'FRA_33': '+33',
  'GUF_594': '+594',
  'PYF_689': '+689',
  'GAB_241': '+241',
  'GMB_220': '+220',
  'GEO_995': '+995',
  'DEU_49': '+49',
  'GHA_233': '+233',
  'GIB_350': '+350',
  'GRC_30': '+30',
  'GRL_299': '+299',
  'GRD_1': '+1',
  'GLP_590': '+590',
  'GUM_1': '+1',
  'GTM_502': '+502',
  'GGY_44': '+44',
  'GIN_224': '+224',
  'GNB_245': '+245',
  'GUY_592': '+592',
  'HTI_509': '+509',
  'VAT_39': '+39',
  'HND_504': '+504',
  'HKG_852': '+852',
  'HUN_36': '+36',
  'ISL_354': '+354',
  'IND_91': '+91',
  'IDN_62': '+62',
  'IRN_98': '+98',
  'IRQ_964': '+964',
  'IRL_353': '+353',
  'IMN_44': '+44',
  'ISR_972': '+972',
  'ITA_39': '+39',
  'JAM_1': '+1',
  'JPN_81': '+81',
  'JEY_44': '+44',
  'JOR_962': '+962',
  'KAZ_7': '+7',
  'KEN_254': '+254',
  'KIR_686': '+686',
  'PRK_850': '+850',
  'KOR_82': '+82',
  'KSV_377': '+377',
  'KSV_381': '+381',
  'KSV_383': '+383',
  'KSV_386': '+386',
  'KWT_965': '+965',
  'KGZ_996': '+996',
  'LAO_856': '+856',
  'LVA_371': '+371',
  'LBN_961': '+961',
  'LSO_266': '+266',
  'LBR_231': '+231',
  'LBY_218': '+218',
  'LIE_423': '+423',
  'LTU_370': '+370',
  'LUX_352': '+352',
  'MAC_853': '+853',
  'MDG_261': '+261',
  'MWI_265': '+265',
  'MYS_60': '+60',
  'MDV_960': '+960',
  'MLI_223': '+223',
  'MLT_356': '+356',
  'MHL_692': '+692',
  'MTQ_596': '+596',
  'MRT_222': '+222',
  'MUS_230': '+230',
  'MYT_262': '+262',
  'MEX_52': '+52',
  'FSM_691': '+691',
  'MDA_373': '+373',
  'MCO_377': '+377',
  'MNG_976': '+976',
  'MNE_382': '+382',
  'MSR_1': '+1',
  'MAR_212': '+212',
  'MOZ_258': '+258',
  'MMR_95': '+95',
  'NAM_264': '+264',
  'NRU_674': '+674',
  'NPL_977': '+977',
  'NLD_31': '+31',
  'NCL_687': '+687',
  'NZL_64': '+64',
  'NIC_505': '+505',
  'NER_227': '+227',
  'NGA_234': '+234',
  'NIU_683': '+683',
  'NFK_672': '+672',
  'MKD_389': '+389',
  'MNP_1': '+1',
  'NOR_47': '+47',
  'OMN_968': '+968',
  'PAK_92': '+92',
  'PLW_680': '+680',
  'PAN_507': '+507',
  'PNG_675': '+675',
  'PRY_595': '+595',
  'PER_51': '+51',
  'PHL_63': '+63',
  'PCN_64': '+64',
  'POL_48': '+48',
  'PRT_351': '+351',
  'PRI_1': '+1',
  'QAT_974': '+974',
  'REU_262': '+262',
  'ROU_40': '+40',
  'RUS_7': '+7',
  'RWA_250': '+250',
  'BLM_590': '+590',
  'SHN_247': '+247',
  'SHN_290': '+290',
  'KNA_869': '+1',
  'LCA_1': '+1',
  'MAF_590': '+590',
  'SPM_508': '+508',
  'VCT_1': '+1',
  'WSM_685': '+685',
  'SMR_378': '+378',
  'STP_239': '+239',
  'SAU_966': '+966',
  'SEN_221': '+221',
  'SRB_381': '+381',
  'SYC_248': '+248',
  'SLE_232': '+232',
  'SGP_65': '+65',
  'SXM_1': '+1',
  'SVK_421': '+421',
  'SVN_386': '+386',
  'SLB_677': '+677',
  'SOM_252': '+252',
  'ZAF_27': '+27',
  'SSD_211': '+211',
  'ESP_34': '+34',
  'LKA_94': '+94',
  'PSE_970': '+970',
  'SDN_249': '+249',
  'SUR_597': '+597',
  'SJM_47': '+47',
  'SWE_46': '+46',
  'CHE_41': '+41',
  'SYR_963': '+963',
  'TWN_886': '+886',
  'TJK_992': '+992',
  'TZA_255': '+255',
  'THA_66': '+66',
  'TLS_670': '+670',
  'TGO_228': '+228',
  'TKL_690': '+690',
  'TON_676': '+676',
  'TTO_1': '+1',
  'TUN_216': '+216',
  'TUR_90': '+90',
  'TKM_993': '+993',
  'TCA_1': '+1',
  'TUV_688': '+688',
  'VIR_1': '+1',
  'UGA_256': '+256',
  'UKR_380': '+380',
  'ARE_971': '+971',
  'GBR_44': '+44',
  'UMI_1': '+1',
  'USA_1': '+1',
  'URY_598': '+598',
  'UZB_998': '+998',
  'VUT_678': '+678',
  'VEN_58': '+58',
  'VNM_84': '+84',
  'WLF_681': '+681',
  'ESH_212': '+212',
  'YEM_967': '+967',
  'ZMB_260': '+260',
  'ZWE_263': '+263',
};



// WEBPACK FOOTER //
// ./src/components/success/pm-phoneCodeRefs.js